<div mat-dialog-content class=" cut-paste-actuation m-t-10">


    <h2 matDialogTitle class="m-b-15" style="text-align: center;">Quitar marca de ausencia justificada</h2>
    <div mat-dialog-content id="leave-popup-fields">
       
    <div mat-dialog-content>
        <p style="text-align: center;">¿Quitar definitivamente la marca de ausencia justificada?</p>
    </div>

    <mat-progress-bar class="m-t-15" mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>

    <div class="text-a-r p-t-10" style="display: flex; justify-content: center;">
        <button class="m-r-15" mat-raised-button color="accent" class="m-r-15" (click)="onAcceptButtonClick()">Si</button>
        <button mat-raised-button color="warn" (click)="closeDialog()">No</button>
    </div>

    </div>
</div>
